export interface BookFeatures {
  text_selection: boolean;
  group_reading: boolean;
  text_search: boolean;
}
